export default __webpack_public_path__ + "static/media/Ana Lúcia Dantas.ff1f5b40.jpg";